// src/components/AppRouter.tsx
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Exchange from "./pages/Exchange";
import CreateBond from "./pages/CreateBond";
import Markets from './pages/Markets';
import Orders from './pages/Orders';
import MyRewards from './pages/MyRewards';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Markets />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/rewards" element={<MyRewards />} />
      <Route path="/exchange/:id" element={<Exchange />} />
      <Route path="/create" element={<CreateBond />} />
    </Routes>
  );
};

export default AppRouter;